import React from 'react';
import './FullScreenIframe.css';

export default props => {
  return (
    <div className="FullScreenIframe">
      <iframe className="FullScreenIframe__Frame" {...props} />
    </div>
  );
};
